import { useState, useEffect } from "react"
import { useNavigate, useLocation } from "react-router"
// import { toast } from "react-toastify"
import Swal from 'sweetalert2';
import Server from "../../Shared/Server"
import Spinner from "../../Shared/Spinner"
import {InputField} from "../../Shared/InputField"
import AsyncSelectField from "../../Shared/AsyncSelect"

const UpdateLineForm = () => {
  const [errors, setErrors] = useState({})
  const [stationOptions, setStationOptions] = useState([])
  const [isLoading, setIsLoading] = useState(false)

  const [formData, setFormData] = useState({
      name: '',
      station_id: "",
      public_id: ''
  })
  const {name, station_id, public_id} = formData

  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {

    if (location.state){
        const {line} = location.state
        setFormData({
            name: line.name,
            station_id: line.station_id,
            public_id: line.public_id
        })
    }

  }, [])
  

  const onChange = (e) => {
      setFormData((prevState) => ({
          ...prevState,
          [e.target.name]: e.target.value
      }))
  }

  const onSubmit = (e) => {
      e.preventDefault()

      const lineData = {name, station_id}
          updateLIne(lineData)
  }
  
  // update line
  const updateLIne = async (lineData) => {
      setIsLoading(true)
      try {
          const response = await Server.put(`/lines/${public_id}`, lineData)
          if (response.status === 200){
              navigate('/lines')
              setIsLoading(false)
            //   toast.success('Successfully updated')
            Swal.fire({
                icon: 'success',
                title: 'Update...',
                text: response.data.detail
              });
          }else{
            //   toast.error(response.data?.detail)
            Swal.fire({
                icon: 'error',
                title: 'Update...',
                text: response.data.detail
              });
          }
      } catch (error) {
          setIsLoading(false)
          if(error.response.status === 401){
              navigate('/login')
          }else if (error.response.status === 422) {
            setErrors({})
            error.response?.data?.detail.map((err) => (
                setErrors((prevState) => ({
                    ...prevState,
                    [err.loc[1]]: err.msg
                }))
            ))
        }else if (error.response.status === 403){
            //   toast.error(error.response.data.detail);
            Swal.fire({
                icon: 'error',
                title: '403',
                text: error.response.data.detail
              });
              navigate('/');
          }else {
            // toast.error(error.response.data.detail);
            Swal.fire({
                icon: 'error',
                title: 'Unkown...',
                text: error.response.data.detail
              });
        }
      }
  }

  const loadOptions = async (query) => {
    try {
      const response = await Server.get('/options/stations', {
        params: { q: query },
      });
      setStationOptions(response.data)
      return response.data;
    } catch (error) {
      return [];
    }
};

  if(isLoading){
      return <Spinner/>
  }

return (
  <>
    <div className="card">
            <div className="card-header p-2 bg-info text-white d-flex justify-content-center">
                <h3 className="card-title">Update Line Form</h3>
            </div>
            <div className="card-body">
                <form onSubmit={onSubmit}>
                    <div className="row">
                        <div className="col-md-6">
                            <AsyncSelectField
                                name="station_id"
                                label="Station"
                                value={station_id}
                                onChange={onChange}
                                loadOptions={loadOptions}
                                options={stationOptions}
                                placeholder="Start typing to search..."
                                error={errors.station_id}
                            />
                        </div>
                        <div className="col-md-6">
                            <InputField
                                placeholder="Line Name"
                                name="name"
                                type="text"
                                label="Name"
                                value={name}
                                onChange={onChange}
                                error={errors.name}
                            />
                        </div>
                    </div>
                    <br/>
                    <div className="row">
                        <div className="col-md-12">
                            <input type="submit" className="btn btn-outline-info" value="Update Line" style={{float: 'right'}}/>
                        </div>
                    </div>
                </form>
            </div>
        </div>
        <br/>
  </>
)
}

export default UpdateLineForm
